<template>
  <div>
    <!-- Confirm 弹窗 -->
    <div v-if="showConfirm" class="dialog-overlay" @click.self="handleConfirmCancel">
      <div class="dialog-container confirm-dialog">
        <div class="dialog-header">
          <div class="dialog-icon confirm">
            <i class="fas fa-question-circle"></i>
          </div>
          <h3 class="dialog-title">{{ confirmOptions.title }}</h3>
          <button class="dialog-close" @click="handleConfirmCancel">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="dialog-body">
          <p>{{ confirmOptions.message }}</p>
        </div>
        <div class="dialog-footer">
          <button class="btn btn-secondary" @click="handleConfirmCancel">
            {{ confirmOptions.cancelText || '取消' }}
          </button>
          <button class="btn btn-primary" @click="handleConfirmOk">
            {{ confirmOptions.okText || '确认' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Alert 弹窗 -->
    <div v-if="showAlert" class="dialog-overlay" @click.self="handleAlertClose">
      <div class="dialog-container alert-dialog" :class="alertOptions.type">
        <div class="dialog-header">
          <div class="dialog-icon" :class="alertOptions.type">
            <i v-if="alertOptions.type === 'success'" class="fas fa-check-circle"></i>
            <i v-else-if="alertOptions.type === 'error'" class="fas fa-exclamation-circle"></i>
            <i v-else-if="alertOptions.type === 'warning'" class="fas fa-exclamation-triangle"></i>
            <i v-else class="fas fa-info-circle"></i>
          </div>
          <h3 class="dialog-title">{{ alertOptions.title }}</h3>
          <button class="dialog-close" @click="handleAlertClose">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="dialog-body">
          <p>{{ alertOptions.message }}</p>
        </div>
        <div class="dialog-footer">
          <button class="btn btn-primary" @click="handleAlertClose">
            {{ alertOptions.okText || '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Tips 轻提示 - 支持多个 -->
    <div class="tips-overlay">
      <div class="tips-container top-center">
        <transition-group name="tips-list" tag="div" class="tips-list-wrapper">
          <div v-for="tip in tipsList" :key="tip.id" class="tips-content" :class="tip.type">
            <i v-if="tip.type === 'success'" class="fas fa-check-circle"></i>
            <i v-else-if="tip.type === 'error'" class="fas fa-exclamation-circle"></i>
            <i v-else-if="tip.type === 'warning'" class="fas fa-exclamation-triangle"></i>
            <i v-else class="fas fa-info-circle"></i>
            <span>{{ tip.message }}</span>
          </div>
        </transition-group>
      </div>
    </div>

    <!-- Loading 加载 -->
    <div v-if="showLoading" class="loading-overlay">
      <div class="loading-container">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring delay-200"></div>
          <div class="spinner-ring delay-400"></div>
        </div>
        <p class="loading-text">{{ loadingOptions.text || '加载中...' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
let tipId = 0

export default {
  name: 'Dialog',
  data() {
    return {
      showConfirm: false,
      showAlert: false,
      showLoading: false,
      confirmOptions: {
        title: '',
        message: '',
        okText: '确认',
        cancelText: '取消',
        onOk: null,
        onCancel: null
      },
      alertOptions: {
        title: '',
        message: '',
        type: 'info',
        okText: '确定',
        onClose: null
      },
      tipsList: [],
      loadingOptions: {
        text: '加载中...'
      }
    }
  },
  methods: {
    confirm(options) {
      this.confirmOptions = {
        title: options.title || '提示',
        message: options.message || '',
        okText: options.okText || '确认',
        cancelText: options.cancelText || '取消',
        onOk: options.onOk || null,
        onCancel: options.onCancel || null
      }
      this.showConfirm = true
    },
    alert(options) {
      this.alertOptions = {
        title: options.title || '',
        message: options.message || '',
        type: options.type || 'info',
        okText: options.okText || '确定',
        onClose: options.onClose || null
      }
      this.showAlert = true
    },
    tips(options) {
      const id = ++tipId

      const tip = {
        id,
        message: options.message || '',
        type: options.type || 'info',
        position: options.position || 'top-center',
        duration: options.duration || 2000
      }
      
      this.tipsList.push(tip)
      
      setTimeout(() => {
        const index = this.tipsList.findIndex(t => t.id === id)
        if (index !== -1) {
          this.tipsList.splice(index, 1)
        }
      }, tip.duration)
    },
    loading(options) {
      this.loadingOptions = {
        text: options.text || '加载中...'
      }
      this.showLoading = true
    },
    closeLoading() {
      this.showLoading = false
    },
    handleConfirmOk() {
      this.showConfirm = false
      if (typeof this.confirmOptions.onOk === 'function') {
        this.confirmOptions.onOk()
      }
    },
    handleConfirmCancel() {
      this.showConfirm = false
      if (typeof this.confirmOptions.onCancel === 'function') {
        this.confirmOptions.onCancel()
      }
    },
    handleAlertClose() {
      this.showAlert = false
      if (typeof this.alertOptions.onClose === 'function') {
        this.alertOptions.onClose()
      }
    }
  }
}
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.dialog-container {
  width: 90%;
  max-width: 420px;
  background: rgba(35, 35, 35, 0.98);
  border-radius: 16px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  animation: dialogScaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialogScaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px;
  background: rgba(170, 170, 170, 0.05);
  border-bottom: 1px solid rgba(170, 170, 170, 0.1);
}

.dialog-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.dialog-icon.confirm {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.dialog-icon.success {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.dialog-icon.error {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.dialog-icon.warning {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.dialog-icon.info {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.dialog-title {
  flex: 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #e8e8e8;
  padding-top: 6px;
}

.dialog-close {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 16px;
}

.dialog-close:hover {
  background: rgba(170, 170, 170, 0.1);
  color: #e8e8e8;
}

.dialog-body {
  padding: 24px;
}

.dialog-body p {
  margin: 0;
  font-size: 14px;
  color: #999;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: rgba(30, 30, 30, 0.9);
}

.btn {
  padding: 10px 28px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(34, 211, 238, 0.15) 100%);
  color: #c4b5fd;
  border: 1px solid rgba(139, 92, 246, 0.4);
}

.btn-primary:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35) 0%, rgba(34, 211, 238, 0.25) 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-secondary {
  background: rgba(170, 170, 170, 0.1);
  color: #999;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.btn-secondary:hover {
  background: rgba(170, 170, 170, 0.2);
  color: #e8e8e8;
}

.alert-dialog.success {
  border-color: rgba(16, 185, 129, 0.3);
}

.alert-dialog.error {
  border-color: rgba(239, 68, 68, 0.3);
}

.alert-dialog.warning {
  border-color: rgba(245, 158, 11, 0.3);
}

.tips-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 10000;
}

.tips-container {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
}

.tips-container.top-center {
  top: 80px;
}

.tips-list-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.tips-content {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  background: rgba(40, 40, 40, 0.95);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  color: #e8e8e8;
}

.tips-list-enter-active {
  animation: tipsSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tips-list-leave-active {
  animation: tipsSlideOut 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes tipsSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes tipsSlideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.tips-content.success {
  border-left: 4px solid #10b981;
}

.tips-content.error {
  border-left: 4px solid #ef4444;
}

.tips-content.warning {
  border-left: 4px solid #f59e0b;
}

.tips-content.info {
  border-left: 4px solid #3b82f6;
}

.tips-content.success i {
  color: #10b981;
}

.tips-content.error i {
  color: #ef4444;
}

.tips-content.warning i {
  color: #f59e0b;
}

.tips-content.info i {
  color: #3b82f6;
}

.tips-content i {
  font-size: 18px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  backdrop-filter: blur(4px);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px 50px;
  background: rgba(35, 35, 35, 0.95);
  border-radius: 16px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.loading-spinner {
  position: relative;
  width: 50px;
  height: 50px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.spinner-ring.delay-200 {
  animation-delay: 0.2s;
  border-top-color: #22d3ee;
}

.spinner-ring.delay-400 {
  animation-delay: 0.4s;
  border-top-color: #a78bfa;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin: 0;
  font-size: 14px;
  color: #999;
}
</style>
